module.exports = __webpack_public_path__ + "static/media/diktat-39.ceb17b1f.mp3";